export default "__VITE_ASSET__DPjUjtoE__"